var _circle, _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgReaderExpand(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 38,
    height: 38,
    viewBox: "0 0 38 38",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 19,
    cy: 19,
    r: 17.5,
    transform: "rotate(90 19 19)",
    fill: "#436094",
    stroke: "#FFFDFC",
    strokeWidth: 3
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.8 16.8833C11.8 16.4169 11.9721 15.9502 12.3182 15.5856C13.035 14.8319 14.2273 14.8018 14.9814 15.5182L19.4132 19.7321L23.8143 15.5225C24.5657 14.8035 25.7581 14.8299 26.4774 15.5816C27.1968 16.3337 27.17 17.5257 26.4183 18.2448L20.7198 23.6962C19.9932 24.3911 18.8487 24.3924 18.1198 23.7005L12.3856 18.2494C11.9968 17.8785 11.8 17.382 11.8 16.8833Z",
    fill: "#FFFDFC"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgReaderExpand);
export default __webpack_public_path__ + "static/media/reader_expand.6232e1b79f7f5001a497655da1bc9810.svg";
export { ForwardRef as ReactComponent };